import type { GridFieldFormModalProps } from "@smartsuite/gridview/lib/components/GridView/GridView.types";
import type {
  AppField,
  Application,
  LinkedRecordFieldParams,
  PermissionAccess,
  Solution,
  WrappedRecord,
} from "@smartsuite/types";
import { useCallback } from "react";

export interface UseLinkedRecordTableFieldActionsProps {
  linkedRecordField: AppField<LinkedRecordFieldParams>;
  application: Application | null;
  solution: Solution | null;
  memberAccess: PermissionAccess;
  visibleFields: string[];
  onChangeLinkedRecordField: (field: AppField<LinkedRecordFieldParams>) => void;
}

export interface UseLinkedRecordTableFieldActionsResult {
  onChangeField: (field: AppField) => void;
  onDeleteField: (field: AppField) => void;
  onDuplicateField: (field: AppField) => void;
  onFieldInfoIconClick: (field: AppField, record: WrappedRecord) => void;
  onOpenFieldFormModal: (data: GridFieldFormModalProps) => void;
  onEditFieldPermissions: (field: AppField) => void;
}

export const useLinkedRecordTableFieldActions = (
  _props: UseLinkedRecordTableFieldActionsProps,
): UseLinkedRecordTableFieldActionsResult => {
  const onChangeField = useCallback((_field: AppField) => undefined, []);
  const onDeleteField = useCallback((_field: AppField) => undefined, []);
  const onDuplicateField = useCallback((_field: AppField) => undefined, []);
  const onFieldInfoIconClick = useCallback(
    (_field: AppField, _record: WrappedRecord) => undefined,
    [],
  );
  const onOpenFieldFormModal = useCallback((_data: GridFieldFormModalProps) => undefined, []);
  const onEditFieldPermissions = useCallback((_field: AppField) => undefined, []);

  return {
    onChangeField,
    onDeleteField,
    onDuplicateField,
    onFieldInfoIconClick,
    onOpenFieldFormModal,
    onEditFieldPermissions,
  };
};
